import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from './PageSEO';

function VerificationInfo() {
  return (
    <main className="App-main">
      <PageSEO title="Landlord Identity Verification | Rentual" description="Verified landlords build tenant trust. Complete identity verification with Stripe to earn a verified badge on your listings." path="/verification" />
      <section className="dashboard-section" style={{ maxWidth: '720px', margin: '0 auto' }}>
        <h2>What “Verified” means</h2>
        <p className="status-text">
          rentual.co verifies landlords to protect renters. Verification helps confirm identity and ownership before any sensitive
          documents are shared.
        </p>

        <div className="card" style={{ marginTop: '1.5rem' }}>
          <h3 style={{ marginTop: 0 }}>Verification levels</h3>
          <ul>
            <li><strong>Unverified</strong> — landlord has not completed verification.</li>
            <li><strong>Verified landlord</strong> — landlord identity has been confirmed.</li>
          </ul>
        </div>

        <div className="card" style={{ marginTop: '1rem' }}>
          <h3 style={{ marginTop: 0 }}>Why it matters</h3>
          <p className="status-text">
            If a landlord is unverified, applications are disabled. You can still send an inquiry, but wait to share sensitive
            documents (SIN, bank details) until verification is complete.
          </p>
        </div>

        <div className="form-actions" style={{ marginTop: '1.5rem' }}>
          <Link className="secondary-button" to="/contact">Contact support</Link>
        </div>
      </section>
    </main>
  );
}

export default VerificationInfo;
